import { useDesk } from '../desk/context';
import { useInteractiveSessions } from '../lib/queries';
import { INSTALLED_APPS } from '../host/registry';
import { interactiveStatus } from './interactiveStatus';
import { t } from '../messages';
export function InteractiveBoard() {
  const { classId, openApp } = useDesk();
  const query = useInteractiveSessions(classId);
  const reader = INSTALLED_APPS.find((app) => app.capabilities?.includes('interactive'));
  if (!query.data?.sessions.length) return null;
  return (
    <section className="activity interactive-board">
      <h2>{t('interactive.studentTitle')}</h2>
      {query.data.sessions.map((s) => (
        <article key={s.id} className="activity-brief interactive-board-card">
          <h3>{s.title}</h3>
          <p>
            {s.correct}
            {' / '}
            {s.total}
            {' · '}
            {s.completed ? t('interactive.completed') : interactiveStatus(s.status)}
          </p>
          {reader ? (
            <button
              className="ndrc-button ndrc-button--primary"
              type="button"
              onClick={() => openApp(reader.id, `/play/${s.id}`)}
            >
              {t(s.completed ? 'interactive.review' : 'interactive.open')}
            </button>
          ) : (
            <p>{t('interactive.noReader')}</p>
          )}
        </article>
      ))}
    </section>
  );
}
